import axios from 'axios';

export default function putWhiteLabel({
  id,
  whiteLabel,
}) {
  return new Promise((resolve, reject) => axios
    .put(`/account/system-admin/api/v1/company/${id}/white_label`,
      {
        white_label: whiteLabel,
      })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message)));
}
